import React from 'react';
import DOMPurify from 'dompurify';

export default function HotelInfoBlock({header, data}) {
  return data ? (
    <div className="hotel__info-block hotel__info-room-types">
      <h4 className="hotel__info-block-header">{header}</h4>
      <div
        className="hotel__info-list-container"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(data),
        }}
      ></div>
    </div>
  ) : null;
}
